/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const getBuildWeekData = params => formatGivenDate( ( params.data.buildWeek ), 'YYYY-MM-DD' );
const getRequestShippingDateData = params => formatGivenDate( params.data.requestShippingDate, 'YYYY-MM-DD' );
const getOrderEntryDateData = params => formatGivenDate( ( params.data.orderEntryDate ), 'YYYY-MM-DD' );

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 120,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
    },
    {
        headerName: 'Build Week',
        sortable: false,
        filter: false,
        width: 100,
        valueGetter: getBuildWeekData
    },
    {
        headerName: 'RSD',
        sortable: false,
        filter: false,
        width: 100,
        valueGetter: getRequestShippingDateData
    },
    {
        headerName: 'Order Entry Date',
        sortable: false,
        filter: false,
        width: 100,
        valueGetter: getOrderEntryDateData
    },
    {
        field: 'effectiveFamily',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'baseCode',
        headerName: 'Base Code',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'creditCode',
        headerName: 'Credit Code',
        sortable: true,
        filter: true,
        width: 110
    }
];

const PastDueOrdersTable = props => (

    <section className="atp-search-result-panel past-due-orders-result-panel ">

        <div className="results-message">
            {`Results as of ${new Date()}`}
        </div>

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PastDueOrdersTable.propTypes = {
    results: PropTypes.array.isRequired,
    time: PropTypes.number,
    oaKey: PropTypes.string
};
export default PastDueOrdersTable;
